import { useDispatch, useSelector } from "react-redux";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { RootState } from "@/store";
import { toggleComparisonLimitShow } from "@/store/slice/uiSlice";

import { Button } from "../ui/button";

export default function ComparsionLimitAlert() {
  const dispatch = useDispatch();
  const { showComparisonPopup } = useSelector((state: RootState) => state.ui);
  return (
    <Dialog
      open={showComparisonPopup.isLimitShow}
      onOpenChange={() => dispatch(toggleComparisonLimitShow())}
    >
      <DialogContent isHideClose>
        <DialogHeader>
          <DialogTitle className="sr-only">Comparison Limit Alert</DialogTitle>
        </DialogHeader>
        <h1 className="text-center text-xl font-semibold text-txtHeading">
          Reach the limit
        </h1>
        <p className="text-sm text-txtBody text-center">
          You have reached the limit to add more data in this comparison
        </p>
        <Button onClick={() => dispatch(toggleComparisonLimitShow())}>
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
}
